import React from "react"
import Layout from "../components/layout"
import Banner from "../components/banner"
import ProvinceList from "../components/province-list"
import WeMakeProcessServingEasy from "../components/we-make-process-serving-easy"
import { Helmet } from "react-helmet"

export default function ProcessServing({ data }) {
  const bannerUrl = "/assets/EFG_6144.jpg";

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Prairie Process Serving</title>
      </Helmet>
      <Banner title="We serve with integrity, respect and results."  imageUrl={bannerUrl}/>
      <section className="section process">
        <div className="container content">
          <h2 className="title is-2 has-text-secondary">Process serving</h2>
          <p>At Prairie Process Serving we understand that being served is a delicate matter, and we strive to always lead with sympathy and compassion.</p>
          <ProvinceList/>

          <h3>Simple. Transparent. Flat Fee.</h3>
          <p>Our flat fee service applies to all the above-noted locations. The flat fee includes:</p>
          <ul style={{"listStyle": "disc"}}>
            <li>Up to 4 attempts</li>
            <li>KMS</li>
            <li>Disbursements (under 20 pages)</li>
            <li>Affidavit of Service/Affidavit of Attempts</li>
          </ul>
          <p><a className="link transition" href="mailto:service@prairieprocessserving.com">Email us</a> today for the set price! For service outside of these communities we follow the "out-of-town" fee schedule. Contact our office now to inquire.</p>
        </div>
      </section>
      <section className="section steps no-top-padding">
        <WeMakeProcessServingEasy/>
      </section>
      <section class="section announcement">
        <div class="container">
          <img class="icon" alt="information icon" src="assets/info-icon.svg"/>
          <p>At this time, we are not accepting service requests from self-represented individuals 
              and are only accepting files directly from law firms and other professional clients. 
              We appreciate your understanding.</p>
        </div>
      </section>
      
    </Layout>
  );
}